import { getEncodedUpload, getFileReader } from '../../../util/FileReader';
import { DevicePolicyEnum } from '../devicePolicy/DevicePolicy';
import { getLogger } from '../../../util/logger';
import bureaucrat from '../../../util/Bureaucrat';
import { parseErrorMessage } from '../../util/dataHelpers';
import routerPaths from '../../util/routerPaths';

const logger = getLogger('settingsUtils');

export const extractFileName = (url) => new URL(url).pathname.split('/').pop();

export const processPromptApiErrors = (errorMsg, defaultPrompts) => {
  const errors = [];

  if (errorMsg) {
    let newErrorMsg = errorMsg;
    // first see if there are any prompt file names in the error msg
    // and replace them with something more descriptive
    defaultPrompts.forEach((prompt) => {
      const videoFileName = extractFileName(prompt.videoPromptUrl);
      newErrorMsg = newErrorMsg.replace(
        videoFileName,
        `"${prompt.name}" slide`,
      );

      prompt?.audioInfos?.forEach((info) => {
        const audioFileName = extractFileName(info.url);
        newErrorMsg = newErrorMsg.replace(
          audioFileName,
          `"${info.name}" audio`,
        );
      });
    });

    newErrorMsg.split('\n').forEach((msg, idx) => {
      const newMsg = idx === 0 ? msg : `${idx}: ${msg}`;
      errors.push(newMsg);
    });
  }
  return errors;
};

const setPromptErrors = (errorMsgs, setErrorMsg, defaultPrompts) => {
  const errorItems = [];

  const newErrorMsgs = processPromptApiErrors(errorMsgs, defaultPrompts);

  newErrorMsgs.forEach((msg) =>
    errorItems.push(
      <div key={errorItems.length} style={{ marginBottom: '10px' }}>
        {msg}
        <br />
      </div>,
    ),
  );

  setErrorMsg(errorItems);
};

const reader = getFileReader();

export const addNewPrompt = (
  setPromptChanges,
  setSubmitEnabled,
  url,
  file,
  isImage = false,
) => {
  const filename = new URL(url).pathname.split('/').pop();

  reader.onencoded = () => {
    setPromptChanges((currentPromptChanges) => ({
      ...currentPromptChanges,
      [filename]: { binaryString: getEncodedUpload(), isImage },
    }));
    setSubmitEnabled(true);
  };

  setSubmitEnabled(false);
  reader.readAsBinaryString(file);
};

export const removeNewPrompt = (setPromptChanges, url) => {
  const filename = new URL(url).pathname.split('/').pop();

  setPromptChanges((currentPromptChanges) => {
    const updatedPrompts = {
      ...currentPromptChanges,
    };

    delete updatedPrompts[filename];

    return updatedPrompts;
  });
};

export const applyDefaultPrompt = (setPromptChanges, url, isImage = false) => {
  const filename = new URL(url).pathname.split('/').pop();

  setPromptChanges((currentPromptChanges) => ({
    ...currentPromptChanges,
    [filename]: { useDefault: true, isImage },
  }));
};

// eslint-disable-next-line no-unused-vars
const exit = (history) => {
  history.push(routerPaths.HOME);
};

export const handleSubmit = async (
  values,
  actions,
  scroll,
  auth,
  policies,
  setErrorMsg,
  promptChanges,
  history,
  defaultPrompts,
  setShowProgress,
  setUpdatePromptsInfo,
) => {
  try {
    setShowProgress(true);
    scroll.scrollToTop();
    const tenant = { ...auth?.tenant };
    if (tenant?.settings === undefined) {
      tenant.settings = {};
    }

    tenant.settings = {
      ...tenant.settings,
      devices: {
        defaultDevicePolicy: values.defaultDevicePolicy
          ? DevicePolicyEnum.trusted
          : DevicePolicyEnum.untrusted,
        policies,
      },
      disableMcuDetection: !values.enableMcuDetection,
      useVideoPrioritizedLayout: values.useVideoPrioritizedLayout,
    };

    logger.debug('updating tenant settings');
    logger.debug(tenant);

    try {
      await bureaucrat.updateTenant(tenant);
      await auth.getTenantProfile();
    } catch (error) {
      actions.setSubmitting(false);
      parseErrorMessage(error, setErrorMsg, history);
      return;
    }

    // only process if we actually have prompt changes
    if (Object.keys(promptChanges).length !== 0) {
      try {
        logger.debug('updating tenant prompts');
        const task = await bureaucrat.updateTenantPrompts(promptChanges);
        setUpdatePromptsInfo({
          task,
          parseErrorMessage: (error) => {
            parseErrorMessage(
              error,
              (errorMsgs) =>
                setPromptErrors(errorMsgs, setErrorMsg, defaultPrompts),
              history,
            );
          },
        });
        // exit(history);
      } catch (error) {
        actions.setSubmitting(false);
        parseErrorMessage(
          error,
          (errorMsgs) =>
            setPromptErrors(errorMsgs, setErrorMsg, defaultPrompts),
          history,
        );
      }
    } else {
      // exit(history);
    }
  } finally {
    setShowProgress(false);
  }
};
